import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'splitAccountByLastDigits'
})
export class SplitAccountByLastDigitsPipe implements PipeTransform {

  constructor(
    protected readonly _sanitizer: DomSanitizer
  ) {}

  transform(_value: number): SafeHtml {
    if (!_value) {
      return '';
    }

    const value = _value.toString();

    if (value.length <= 3) {
      return this._sanitizer.bypassSecurityTrustHtml(value);
    }

    return this._sanitizer.bypassSecurityTrustHtml(this._getTransformedValue(value));
  }

  private _getTransformedValue(value: string): string {
    return value.slice(0, -3) + ' ' + value.substr(value.length - 3);
  }

}
